import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ptBR from "../locales/pt-BR.json";
import en from "../locales/en.json";
import es from "../locales/es.json";

export const SUPPORTED_LOCALES = ["pt-BR", "en", "es"];
export const STORAGE_KEY = "rdmapps-locale";

const resources = {
  "pt-BR": { translation: ptBR },
  en: { translation: en },
  es: { translation: es },
};

// Reduz variantes tipo "en-US"/"es-ES"/"pt-PT" ao idioma suportado mais
// próximo — sem isto o navigator.language de um visitante americano
// ("en-US") não bateria com o "en" que temos em resources.
function normalizeLocale(locale) {
  if (!locale) return undefined;
  if (SUPPORTED_LOCALES.includes(locale)) return locale;
  const lang = locale.split("-")[0].toLowerCase();
  if (lang === "pt") return "pt-BR";
  return SUPPORTED_LOCALES.find((candidate) => candidate.split("-")[0] === lang);
}

// Prioridade: escolha explícita salva neste navegador (localStorage) >
// locale vindo do Rails via data-parameters (reflete current_user.locale
// para quem está logado) > idioma do navegador > pt-BR.
function detectLocale(initialLocale) {
  const stored = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;

  return (
    normalizeLocale(stored) ||
    normalizeLocale(initialLocale) ||
    normalizeLocale(typeof navigator !== "undefined" ? navigator.language : undefined) ||
    "pt-BR"
  );
}

// Idempotente: as duas SPAs (pública e logada) chamam initI18n no próprio
// entrypoint, mas a suíte de testes também chama uma vez no setup global —
// sem a guarda, o segundo init reiniciaria o idioma detectado.
export function initI18n(initialLocale) {
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      resources,
      lng: detectLocale(initialLocale),
      fallbackLng: "pt-BR",
      supportedLngs: SUPPORTED_LOCALES,
      interpolation: { escapeValue: false },
    });
  }
  return i18n;
}

// Troca o idioma ativo e persiste a escolha para a próxima visita. Sem seletor
// na UI nesta fase (ADR-017; superfícies aposentadas removidas em 2026-10-10 —
// o primitivo language-switcher.jsx segue no kit ui/); persistência no
// current_user.locale (quando logado) é feita à parte via PATCH /admin/locale.json.
export function changeLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  window.localStorage.setItem(STORAGE_KEY, locale);
  i18n.changeLanguage(locale);
}

export default i18n;
